import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs"
import { Box, Typography } from "@mui/material";

type Props = {
    open: boolean;
    setOpen: (open: boolean) => void;
    documentsArray: any;
}

const VerDocumentosHabilitantesContractuales = ({
    open,
    setOpen,
    documentsArray
}: Props) => {
  return (
    <ScrollableDialogProps
        open={open}
        onClose={() => setOpen(false)}
        title={
          documentsArray?.documentos_habilitantes 
          && documentsArray?.documentos_habilitantes?.length > 0?
          "Documentos Habilitantes"
          :
          documentsArray?.documentos_contractuales 
          && documentsArray?.documentos_contractuales?.length > 0?
          "Documentos Contractuales"
          :
          "Documentos No Cargados"
        }
        contentNode={
          <>
            {
              documentsArray?.documentos_habilitantes?.length > 0?
              documentsArray?.documentos_habilitantes.map((document: any, index: number) => (
                <Box key={`document-${document?.name}`} sx={{mb: 2}}>
                  <a href={document?.url} 
                  target="_blank" rel="noopener noreferrer">
                    <Typography>Documento Habilitante {index + 1}</Typography>
                  </a>
                </Box>
              ))
              :
              documentsArray?.documentos_contractuales?.length > 0?
              documentsArray?.documentos_contractuales.map((document: any, index: number) => (
                <Box key={`document-${document?.name}`} sx={{mb: 2}}>
                  <a href={document?.url} target="_blank" rel="noopener noreferrer">
                    <Typography>Documento Contractual {index + 1}</Typography>
                  </a>
                </Box>
              ))
              :
              <Typography>No hay documentos cargados</Typography>
            }

          </>
        }
      />
  )
}

export default VerDocumentosHabilitantesContractuales